import { isString } from 'lodash';

import { FormContextValues } from '@dreryk/react-common';
import { Notification, NotificationSize, NotificationType, StyledFlex, TextInput } from '@dreryk/react-components';

import { nfzLoginTranslationKeys } from '../../../../translations';

const MFA_TOTP_FIELD_NAME = 'mfaTotp';
const MFA_TOTP_MIN_LENGTH = 6;
const MFA_TOTP_MAX_LENGTH = 6;
const MFA_TOTP_PATTERN = /^\d{6}$/u;

export type MfaTotpFormBeanPart = { [MFA_TOTP_FIELD_NAME]: string | null };

type MfaTotpProps = Pick<FormContextValues<MfaTotpFormBeanPart>, 'register'>;

export const MfaTotpField = (props: MfaTotpProps): JSX.Element => {
   return (
      <StyledFlex gap={8} direction={'column'}>
         <TextInput
            label={nfzLoginTranslationKeys.mfaTotp.label}
            controller={props.register(MFA_TOTP_FIELD_NAME, {
               required: true,
               minLength: MFA_TOTP_MIN_LENGTH,
               maxLength: MFA_TOTP_MAX_LENGTH,
               validate: (value) => {
                  if (isString(value) && !MFA_TOTP_PATTERN.test(value)) {
                     return nfzLoginTranslationKeys.mfaTotp.validation.invalidValue;
                  }

                  return undefined;
               },
            })}
            testId={MFA_TOTP_FIELD_NAME}
         />

         <Notification
            testId={'mfaTotpInfo'}
            type={NotificationType.INFO}
            size={NotificationSize.SMALLER}
            label={nfzLoginTranslationKeys.enterMfaTotp}
         />
      </StyledFlex>
   );
};
